var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34170_45847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6778 12.2227C21.6778 13.9873 21.1545 15.7123 20.1742 17.1795C19.1938 18.6467 17.8004 19.7902 16.1701 20.4655C14.5399 21.1408 12.746 21.3175 11.0153 20.9732C9.2846 20.6289 7.69487 19.7792 6.44711 18.5315C5.19936 17.2837 4.34963 15.694 4.00537 13.9633C3.66112 12.2326 3.8378 10.4387 4.51308 8.80843C5.18836 7.17817 6.33191 5.78475 7.79911 4.8044C9.26632 3.82404 10.9913 3.30078 12.7559 3.30078C15.254 3.30078 17.6431 4.29211 19.4374 6.01701L21.6778 8.25741",
    stroke: "white",
    strokeWidth: 2.37918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6779 3.30078V8.25741H16.7213",
    stroke: "white",
    strokeWidth: 2.37918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5886 11.4444V10.3702L11.145 9.82889V15.7578H9.98756V11.078L8.5886 11.4444ZM12.9835 12.8433C12.9835 13.1375 13.0113 13.4068 13.0668 13.651C13.1223 13.8898 13.2028 14.0979 13.3083 14.2756C13.4138 14.4477 13.5387 14.5809 13.683 14.6753C13.8273 14.7697 13.9883 14.8168 14.166 14.8168C14.3492 14.8168 14.5129 14.7697 14.6573 14.6753C14.8016 14.5809 14.9265 14.4477 15.032 14.2756C15.1375 14.0979 15.218 13.8898 15.2735 13.651C15.329 13.4068 15.3567 13.1375 15.3567 12.8433C15.3567 12.5491 15.329 12.2826 15.2735 12.0439C15.218 11.7996 15.1375 11.5915 15.032 11.4194C14.9265 11.2417 14.8016 11.1057 14.6573 11.0113C14.5129 10.917 14.3492 10.8698 14.166 10.8698C13.9883 10.8698 13.8273 10.917 13.683 11.0113C13.5387 11.1057 13.4138 11.2417 13.3083 11.4194C13.2028 11.5915 13.1223 11.7996 13.0668 12.0439C13.0113 12.2826 12.9835 12.5491 12.9835 12.8433ZM11.826 12.8433C11.826 12.2271 11.9232 11.6942 12.1175 11.2445C12.3173 10.7948 12.5921 10.4479 12.9419 10.2036C13.2972 9.9538 13.7052 9.82889 14.166 9.82889C14.6434 9.82889 15.057 9.9538 15.4067 10.2036C15.7564 10.4479 16.0285 10.7948 16.2228 11.2445C16.4171 11.6942 16.5142 12.2271 16.5142 12.8433C16.5142 13.4595 16.4171 13.9925 16.2228 14.4421C16.0285 14.8918 15.7564 15.2415 15.4067 15.4913C15.057 15.7356 14.6434 15.8577 14.166 15.8577C13.7052 15.8577 13.2972 15.7356 12.9419 15.4913C12.5921 15.2415 12.3173 14.8918 12.1175 14.4421C11.9232 13.9925 11.826 13.4595 11.826 12.8433Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34170_45847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7918,
    height: 23.7918,
    fill: "white",
    transform: "translate(0.858902 0.326172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoForward);
export default __webpack_public_path__ + "static/media/video-forward.2b54bba39ad774072619a73010c2e996.svg";
export { ForwardRef as ReactComponent };